export default "__VITE_ASSET__Bwo9RqZx__"